<platform-idle></platform-idle>
<div class="container-header">
  <platform-header></platform-header>
</div>
<div class="container-body">
  <div class="container-nav" [ngClass]="{ 'maximize': isOpen }">
    <nav *ngIf="isOpen; else showTieredMenu" class="menu-container">
      <app-menu [items]="items"></app-menu>
    </nav>
    <ng-template #showTieredMenu>
      <nav class="menu-container menu-container--tiered">
        <app-tiered-menu [items]="items"></app-tiered-menu>
      </nav>
    </ng-template>
  </div>
  <div class="container-content" [ngClass]="{ 'maximize': isOpen }">
    <router-outlet></router-outlet>
  </div>
</div>